import React from 'react';
import { Button } from 'react-bootstrap';
import { FaSearch, FaCompass, FaExclamationCircle } from 'react-icons/fa';
import './EmptyState.css';

const EmptyState = ({ 
  icon: Icon = FaSearch,
  title = 'No Results Found',
  message = 'Try adjusting your filters or search criteria',
  actionLabel,
  onAction,
  type = 'default' // default, search, error
}) => {
  // Choose icon based on type if not explicitly provided
  const DisplayIcon = Icon || (type === 'error' ? FaExclamationCircle : type === 'search' ? FaSearch : FaCompass);

  return (
    <div className={`empty-state empty-state-${type}`}>
      <div className="empty-state-icon">
        <DisplayIcon />
      </div>
      <h3 className="empty-state-title">{title}</h3>
      <p className="empty-state-message">{message}</p>
      {actionLabel && onAction && (
        <Button 
          variant="primary" 
          onClick={onAction}
          className="empty-state-action"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
